import { NgModule } from '@angular/core';

import { PontosComponent } from './pontos.component';
import {SharedModule} from "../../shared/shared.module";
import {PontosRoutingModule} from "./pontos-routing.module";
import {PontoApiService} from "./shared/ponto-api.service";
import {PontoNavigationService} from "./shared/ponto-navigation.service";
import {PontoService} from "./shared/ponto.service";
import {PontoFormComponent} from "./ponto-form/ponto-form.component";
import {PontoListComponent} from "./ponto-list/ponto-list.component";
import {EnderecosModule} from "../../estruturas/enderecos/enderecos.module";
import { PontoTableComponent } from './ponto-table/ponto-table.component';
import {PontoDeslocamentoFormListComponent} from "./ponto-deslocamento-form-list/ponto-deslocamento-form-list.component";

@NgModule({
    imports: [
        SharedModule,
        EnderecosModule,
        PontosRoutingModule
    ],
    providers: [
        PontoApiService,
        PontoNavigationService,
        PontoService
    ],
    declarations: [
        PontosComponent,
        PontoFormComponent,
        PontoListComponent,
        PontoTableComponent,
        PontoDeslocamentoFormListComponent
    ],
    exports: [
        PontoTableComponent,
        PontoDeslocamentoFormListComponent
    ]
})
export class PontosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/pontos.module.ts
 **/